module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "int-head"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-c"
  }, [_c('i', [_vm._v("“Have nothing in your house that you do not find useful or believe to be beautiful.” —William Morris")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Taking the advice from Mr. Morris, we can transform our useful into beautiful and thereby have the best of both worlds: a tablet purse becomes an embroidered masterpiece and a functional tea cozy can double as an eye-catching centerpiece on our table.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Welcome to a world of crazy quilting, where any type of fabric goes: bright and bold, subdued Japanese cottons, “upcycled” wool, pretty ginghams, and vintage doilies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each project comes with detailed assembly instructions and easy-to-follow stitch maps. The pullout pattern sheets include full-size patterns for each project.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The comprehensive stitch dictionary includes silk ribbon and basic embroidery, beading, and embellishing stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whether you are a new crazy quilter or an experienced crazy quilter looking for smaller projects to go “crazy” on, I am sure you will find something to inspire you.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("China flower pincushion")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Tea Cozy and Tablet Purse")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f2ce3a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_intro.vue
// module id = 69
// module chunks = 0